<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="다운로드 쿠폰 조회"
      desc="등록한 다운로드 쿠폰들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="selectCoupons"
              class="button is-primary">선택 쿠폰 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>
      <!-- 발행 유형 -->
      <div slot="type" slot-scope="props">
        <div>{{ couponType(props.item.publish_type) }}</div>
      </div>

      <!-- 발행하기 -->
      <div slot="publish_status" slot-scope="props">
        <div v-if="enablePublish(props.item)">
          <button class="button half"
                  style="margin-top:8px"
                  @click="$router.push(`coupon/user/create?id=${props.item.id}`)">발행</button>
        </div>
        <div v-else-if="props.item.partners.indexOf($store.getters.partner.partner_id)>-1">
          발행 완료
        </div>
        <div v-else>-</div>
      </div>

      <!-- 종료날짜 -->
      <div slot="end_date" slot-scope="props">
        <div>{{ endDate(props.item) }}</div>
      </div>

      <div slot="download_period" slot-scope="props">
        <div>{{ downloadPeriod(props.item) }}</div>
      </div>

      <!-- 할인 부담 유형 -->
      <div slot="burden_type" slot-scope="props">
        <div v-if="props.item.burden_type===0">플랫폼 전체 부담</div>
        <div v-else-if="props.item.burden_type===1">플랫폼+파트너사 함께 부담</div>
        <div v-else-if="props.item.burden_type===2">파트너 자체 발행</div>
      </div>

      <!-- 발행 상태 -->
      <div slot="activate" slot-scope="props">
        <div v-if="props.item.activate">발행중</div>
        <div v-else>발행중지</div>
      </div>

      <div slot="discount" slot-scope="props">
        <!-- 할인율 -->
        <div v-if="props.item.discount_type===0">
          {{ props.item.discount_rate }} %
        </div>
        <!-- 할인 금액 -->
        <div v-if="props.item.discount_type===1">
          {{ props.item.discount_price }} 원
        </div>
      </div>

      <!-- 발행 내역 관리 -->
      <div slot="management" slot-scope="props">
        <button class="button half"
                @click="$router.push(`coupon/user?id=${props.item.id}`)"
                v-if="managePublish(props.item)">관리</button>
        <div v-else>-</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <div v-if="enableEdit(props.item)">
          <!--<button class="button half"
                  @click.stop.prevent="clickModifyDelete(props.item,'update')"
                  style="margin-right:4px">수정</button>-->
          <button class="button half is-danger"
                  @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
        </div>
        <div v-else>-</div>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../../module/common/LpCheckBool";
  export default {
    name: "DownloadCouponList",
    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    watch: {
      '$route'(n) {
        console.log(n)
        this.getList();
      }
    },
    created() {
      this.init();

    },
    methods: {
      init() {
        this.getList();
      },
      getDataFromServer() {
        this.getData();
      },
      getList() {
        this.initializing('download_coupon', `coupon?publish_type=2`);
      },
      managePublish(item) {
        if(this.isAdmin) return true;
        else {
          if(item.burden_type>0) return true;
        }
      },
      // 편집(수정 삭제) 권한
      enableEdit(item) {
        if(this.isAdmin) return true;
        else {
          if(item.partner) {
            if(item.partner === this.$store.getters.partner.partner_id) return true
            else return false;
          }
        }
      },
      // 종료 날짜
      endDate(item) {
        return this.getEndDate(item);
      },
      getEndDate(item) {
        if(item.limit_type===0) {
          // return moment(item.created_time).add(item.few_day).format('YYYY-MM-DD');
          return `쿠폰 받은 날로 부터 ${item.few_day}일 이내 사용`
        }
        else if(item.limit_type===1) {
          return item.end_date;
        }
        else if(item.limit_type===3) {
          return '없음';
        }
        else {
          return `${item.coupon_start} ~ ${item.coupon_end}`;
        }
      },
      // 발급 버튼 활성화 여부
      enablePublish(item) {
        // publish_type: 발급 유형 (0:수동발급, 1:조건부 발행)
        // burden_type: 발급 부담 유형 (0:플랫폼, 1:플랫폼+파트너, 2:파트너)
        // 날짜가 지나버렸을 경우 비노출
        // let end = moment(this.endDate(item));
        // let now = moment(moment().format('YYYY-MM-DD'));
        // let remain = moment.duration(end.diff(now)).asDays();
        // if(remain<0) return false;
        if (!this.isAdmin && item.burden_type===0) {
          return false;
        }
        // 할인 부담 유형 플랫폼 + 파트너 함께 부담일 경우 관리자는 비활성화
        if(this.isAdmin) {
          // 플랫폼 발행 아닌경우 비활성화
          if(item.burden_type>0) return false;
          // 조건부 발행일 경우 비활성화
          else if(item.publish_type===1) return false;
          else return true;
        }
        else {
          // 플랫폼이 발급 부담할 경우 비활성화
          if(item.burden_type===0) return false;
          // 조건부 발행일 경우 비활성화
          else if(item.publish_type===1) return false;
          else return true;
        }
        // 쿠폰 시간 유효성 체크
        // if (item.limit_type===0) {
        //   return true;
        // }
        // let end_date = this.getEndDate(item);
        // let remain = parseInt(moment.duration(moment(end_date).diff(moment())).asDays());
        // if (remain<0) return false;
        // else if(parseInt(remain)===0) {

        // }
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`coupon/create?id=${item.id}`));
        }
        else if(type === 'delete') {
          let value = {
            url: `coupon/${item.id}`,
            title: `${item.name} 쿠폰을 삭제하시겠습니까?`
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      couponType(type) {
        if(type===0) return '수동 발행';
        else if(type===1) return '조건부 발행';
      },
      downloadPeriod(item) {
        if(item.download_start && item.download_end) {
          return `${item.download_start} ~ ${item.download_end}`;
        }
        else if(item.download_start) {
          return `${item.download_start} ~`;
        }
        else if(item.download_end) {
          return `~${item.download_end}`;
        }
        else {
          return '';
        }
      },
      selectCoupons() {
        let tableItems = [];
        let id_list = [];
        for(let i=0; i<this.showcaseCheckArr.length; i++){
          for(let j=0; j<this.tableItems.length; j++){
            if(this.showcaseCheckArr[i].value && this.showcaseCheckArr[i].id===this.tableItems[j].id){
              tableItems.push(this.tableItems[j]);
              id_list.push(this.tableItems[j].id);
            }
          }
        }
        //console.log(tableItems)
        this.$emit('tableItems', {
          tableItems: tableItems,
          id_list: id_list
        });
      }
    }
  }
</script>

<style scoped>

</style>
